import { connect } from "react-redux";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory, useParams } from "react-router";
import StatusLayout from "components/Status";
import { IconButton } from "@mui/material";

function PartnerAssignedProjects({ loggedUser, location, SetSelectedMenu }) {
    const [open, setOpen] = useState(0);
    const [value, setValue] = useState({});
    const [list, setList] = useState([]);
    const [activityList, setActivityList] = useState([]);
    const [id, setId] = useState();
    const [userId, setUserId] = useState(loggedUser?.partnerId);

    const [count, setCount] = useState(0);

    const [deleteOpen, setDeleteOpen] = useState(false);

      const history = useHistory();

    useEffect(() => {
        SetSelectedMenu({
            menu: "assigned-projects",
            title: "Assigned Project(s)",
        });
    }, []);

    useEffect(() => {
      setCount(0);

    }, [loggedUser])

     const columns = [
       {
         name: "code",
         label: "Code",
         options: {
           filter: true,
           sort: true,
           customBodyRender: (value) => (
             <span className="text-custom-blue text-xs ">{value}</span>
           ),
         },
       },
       {
         name: "name",
         label: "Name",
         options: {
           filter: true,
           sort: true,
           customBodyRender: (value) => (
             <span className="text-custom-blue text-xs ">{value}</span>
           ),
         },
       },
       // {
       //   name: "Activities",
       //   label: "Activities",
       //   options: {
       //     filter: true,
       //     sort: true,
       //     customBodyRender: (value) => (
       //       <span className="text-[#A1A1A1] text-xs font-lighter">5</span>
       //     ),
       //   },
       // },
   
       {
         name: "startDate",
         label: "Start Date",
         options: {
           filter: true,
           sort: true,
           customBodyRender: (value) => (
             <span className="text-[#A1A1A1] text-xs">
               {moment(value).format("DD/MM/yyyy") ?? ""}
             </span>
           ),
         },
       },
       {
         name: "endDate",
         label: "End Date",
         options: {
           filter: true,
           sort: true,
           customBodyRender: (value) => (
             <span className="text-[#A1A1A1] text-xs">
               {moment(value).format("DD/MM/yyyy") ?? ""}
             </span>
           ),
         },
       },
      //  {
      //    name: "budget",
      //    label: "Budget",
      //    options: {
      //      filter: true,
      //      sort: true,
      //      customBodyRender: (value) => (
      //        <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
      //      ),
      //    },
      //  },
      //  {
      //   name: "PartnerAssignments",
      //   label: "Allocated Amount",
      //   options: {
      //     filter: true,
      //     sort: true,
      //     customBodyRender: (value) => {
      //       const amount = value?.reduce((acc, curr) => acc + curr?.amount, 0);
      //      return <span className="text-[#A1A1A1] text-xs font-lighter">{amount}</span>
      //     },
      //   },
      //  },
      //  {
      //   name: "PartnerAssignments",
      //   label: "Spent",
      //   options: {
      //     filter: true,
      //     sort: true,
      //     customBodyRender: (value) => {
      //       const receivedAmount = value?.reduce((acc, curr) => acc + curr?.receivedAmount, 0);
      //       return <span className="text-[#A1A1A1] text-xs font-lighter">{receivedAmount}</span>;
      //     }
      //   },
      //   },
      //   {
      //       name: "id",
      //       label: "Balance",
      //       options: {
      //           filter: true,
      //           sort: true,
      //           customBodyRender: (value) => {
      //             const partner = list.find((x) => x.id === value);
      //               const receivedAmount = partner?.PartnerAssignments?.reduce((acc, curr) => acc + curr?.receivedAmount, 0);
      //               const allocatedAmount = partner?.PartnerAssignments?.reduce((acc, curr) => acc + curr?.amount, 0);
      //              return  <span className="text-custom-blue text-xs ">{
      //               allocatedAmount - receivedAmount
      //               }</span>
      //           }
      //       },
      //   },
       {
         name: "id",
         label: "Action",
         options: {
           filter: false,
           sort: false,
           customBodyRender: (v) => (
             <div className="flex items-center">
   
               <IconButton onClick={() => {
                 history.push(`/admin/assigned-projects/details/${v}`);
               }}>
                 <img
                   src={require("../../assets/icons/eye.svg").default}
                   alt="Decorative SVG"
                   className={
                     " mr-2 text-sm text-blueGray-300"
                   }
                 />
               </IconButton>
   
             </div>
           ),
         },
       },
     ];


     const ActivityColumns = [
         {
              name: "name",
              label: "Name",
              options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                  <span className="text-custom-blue text-xs ">{value}</span>
                ),
              },
            },  
            {
              name: "startDate",
              label: "Start Date",
              options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                  <span className="text-[#A1A1A1] text-xs">
                    {moment(value).format("DD/MM/yyyy") ?? ""}
                  </span>
                ),
              },
            },
            {
              name: "endDate",
              label: "End Date",
              options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                  <span className="text-[#A1A1A1] text-xs">
                    {moment(value).format("DD/MM/yyyy") ?? ""}
                  </span>
                ),
              },
            },
            {
              name: "partners",
              label: "Partner Type",
              options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                  const partnerType = value?.map((x) => x.partnerType).join(", ");
                 return <span className="text-[#A1A1A1] text-xs">
                    {partnerType}
                  </span>
                },
              },
            },
            {
              name: "partners",
              label: "Allocated Amount",
              options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                  const amount = value?.reduce((acc, curr) => acc + curr?.amount, 0);
                 return <span className="text-[#A1A1A1] text-xs font-lighter">{amount}</span>
                },
              },
            },
            {
             name: "partners",
             label: "Spent",
             options: {
               filter: true,
               sort: true,
               customBodyRender: (value) => {
                 const receivedAmount = value?.reduce((acc, curr) => acc + curr?.receivedAmount, 0);
                 return <span className="text-[#A1A1A1] text-xs font-lighter">{receivedAmount}</span>;
               }
             },
             },
                    {
           name: "id",
           label: "Balance",
           options: {
               filter: true,
               sort: true,
               customBodyRender: (value) => {
                 const activity = activityList.find((x) => x.id === value);
                 const receivedAmount = activity?.partners?.reduce((acc, curr) => acc + curr?.receivedAmount, 0);
                 const allocatedAmount = activity?.partners?.reduce((acc, curr) => acc + curr?.amount, 0);
                  return  <span className="text-custom-blue text-xs ">{
                        allocatedAmount - receivedAmount
                   }</span>
               }
           },
       },
            {
              name: "status",
              label: "Status",
              options: {
                filter: true,
                sort: true,
                customBodyRender: (status) => {
                  return (
                    <span style={{ fontSize: "0.85rem" }}>
                      <StatusLayout status={status} />
                    </span>
                  );
                },
              },
            },
            {
              name: "impact",
              label: "Impact",
              options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                  <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
                ),
              },
            },
    ];

    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue((v) => {
            v[name] = val;
            return { ...v };
        });
    };
    const onSuccess = () => setCount((v) => v + 1);
    return (
        <div className="w-full mb-12 px-4">
            <DeleteDialog
                open={deleteOpen}
                setOpen={() => setDeleteOpen(false)}
                onSuccess={onSuccess}
                url={`/api/funder/delete/${id}`}
            />

            <FormDialog
                maxWidth={"md"}
                col={6}
                open={open > 0}
                onSuccess={onSuccess}
                setOpen={setOpen}
                url={open === 1 ? "/api/funder/create" : `/api/funder/update/${id}`}
                title={open === 1 ? "Create New Funder" : "Edit Funder"}
                fields={[
                    {
                        name: "name",
                        label: "Funder name",
                        value: value["name"],
                        required: true,
                        setValue: (val) => setValue0("name", val),
                    },
                    {
                        name: "representative",
                        label: "Representative",
                        value: value["representative"],
                        required: false,
                        type: 'text',
                        setValue: (val) => setValue0("representative", val),
                    },
                    {
                        name: "address",
                        label: "Address",
                        type: "text",
                        value: value["address"],
                        required: true,
                        setValue: (val) => setValue0("address", val),
                    },
                    {
                        name: "email",
                        label: "Email",
                        type: "text",
                        value: value["email"],
                        required: true,
                        setValue: (val) => setValue0("email", val),
                    },
                    {
                        name: "phone",
                        label: "Phone",
                        type: "text",
                        value: value["phone"],
                        required: true,
                        setValue: (val) => setValue0("phone", val),
                    },


                ]}
            />
            <DatatableComponent
                processData={(data) => {
               
                    setList(data?.data);
                    return data;
                }}
                expandableRows={false}
                  onRowClick={(data, { rowIndex }) => {
                        const project = list[rowIndex];
                   
                        history.push(`/admin/assigned-projects/details/${project.id}`);
                    
                    }
                }
                renderExpandableRow={(rowData, rowMeta) => {
                    const partner = list[rowMeta.dataIndex];
                    const activities = partner?.activities;
                    setActivityList(activities);
                    return (
                        <tr>
            <td colSpan={12}>
              <div className="w-full p-10">
                <DatatableComponent
                initialData={activities}
             
                onRowSelectionChange={(list) => {}
                }
                elevation={1}
                pdf={false}
                excel={false}
                url={'/api/partner/activities'}
                columns={ActivityColumns}
                viewColumns={false}
                searchfield={false}
                search={false}
               
                title={
                    "All Activities"
                }
            />
            
                </div>
                            </td>
                        </tr>
                    );
                }
                }
                elevation={1}
                pdf={false}
                excel={false}
                columns={columns}
                viewColumns={false}
                searchfield={true}
                search={false}
                url={`/api/partner/projects/${loggedUser?.partnerId}?count=${count}`}
                title={
                    "All Projects"
                }
            />
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerAssignedProjects);
